export const activity = {
  log: {
    title: "Journal des modifications - #{{id}}",
    context: "Contexte",
    changes: "Changements",
    subject: "Sujet",
    subjectType: "Type de sujet",
    subjectIds: "Ids des sujets",
    event: "Événement",
    description: "Description",
    date: "Date",
    causedBy: "Causé par",
    requestedBy: "Demandé par",
    currentState: "État actuel",
  },
  event: "Événement",
  subject: "Sujet",
  subjectType: "Type du sujet",
  staticState: {
    created: "Créé",
    updated: "Mis à jour",
    deleted: "Supprimé",
    restore: "Restauré",
    restored: "Restauré",
    batch: {
      updated: "Mis à jour en lot",
      deleted: "Supprimé en lot",
      restore: "Restauré en lot",
    },
    import: {
      created: "Créé en import",
      updated: "Mis à jour en import",
    },
  },
};
